import React from 'react';
import {
  Dialog,
  Box,
  Typography,
} from '@mui/material';
import { Check } from 'lucide-react';

interface ChangesSavedDialogProps {
  open: boolean;
  onClose: () => void;
}

function ChangesSavedDialog({ open, onClose }: ChangesSavedDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          padding: '48px 24px',
          textAlign: 'center',
          backgroundImage: 'url(/hub/congrats_bg.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          maxWidth: '400px',
        },
      }}
    >
      <Box
        sx={{
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          backgroundColor: 'rgba(232, 245, 233, 1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
        }}
      >
        <Check
          size={24}
          strokeWidth={2.5}
          color="#4CAF50"
        />
      </Box>

      <Typography
        sx={{
          fontSize: '28px',
          fontWeight: 500,
          lineHeight: 1.25,
          color: 'rgba(0, 0, 0, 0.87)',
          mb: 2,
        }}
      >
        Changes saved
      </Typography>

      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          color: 'primary.text',
        }}
      >
        Your pet&apos;s profile has been updated
      </Typography>
    </Dialog>
  );
}

export default ChangesSavedDialog;
